import { Component, Input } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { StudentOfConcernInterviewService } from '../../../../shared/services/studentOfConcernInterview.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';

@Component({
  selector: 'review-student-of-concern-interview',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-student-of-concern-interview.component.html',
  styleUrl: './review-student-of-concern-interview.component.css'
})
export class ReviewStudentOfConcernInterviewComponent {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  studentInterview: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Interview Information",
      children: [
        {
          type: 'date',
          questionText: "Date of Interview:",
          answer: "date_interview"
        },
        {
          type: 'string',
          questionText: "Time of Interview:",
          answer: "time_interview"
        },
        {
          type: 'string',
          questionText: "Person Conducting Interview:",
          answer: "person_conducting_interview"
        }
      ]
    },
    {
      sectionName: "Situation Review",
      children: [
        {
          type: 'string',
          questionText: "Do you know why I wanted to talk with you?",
          answer: "reason_for_talking"
        },
        {
          type: 'string',
          questionText: "Explain what happened, including where and when.",
          answer: "what_happened"
        },
        {
          type: 'string',
          questionText: "Who else was present when this occurred?",
          answer: "other_presence"
        },
        {
          type: 'string',
          questionText: "What exactly did you do? (Write down the student's exact words.)",
          answer: "student_word_actions"
        },
        {
          type: 'string',
          questionText: "What exactly did you say? (Write down the student's exact words.)",
          answer: "student_words"
        },
        {
          type: 'string',
          questionText: "What did you mean when you said or did that?",
          answer: "student_meaning"
        },
        {
          type: 'number',
          questionText: "Do you have access to weapons or dangerous items?",
          answer: "access_weapon"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "access_weapon_information"
        }
      ]
    },
    {
      sectionName: "Impact on Others",
      children: [
        {
          type: 'string',
          questionText: "How do you think the persons or group you threatened feels about what you said or did?",
          answer: "target_feelings"
        },
        {
          type: 'string',
          questionText: "What was the reason you said or did that?",
          answer: "reason"
        },
        {
          type: 'string',
          questionText: "What are you going to do now that this has happened?",
          answer: "next_actions"
        },
        {
          type: 'string',
          questionText: "How will or did your parents respond to this situation?",
          answer: "parent_response"
        },
        {
          type: 'string',
          questionText: "Are there others in your family who are or will be aware, and how will they respond?",
          answer: "family_response"
        }
      ]
    },
    {
      sectionName: "Support Resources/Summary",
      children: [
        {
          type: 'string',
          questionText: "Who in the school do you talk to when you have problems?",
          answer: "problems",
        },
        {
          type: 'string',
          questionText: "Who do you talk to outside of school (home, family, friends) when you have problems?",
          answer: "outside_school",
        },
        {
          type: 'string',
          questionText: "What else would you like to share about this situation?",
          answer: "other_information",
        },
        {
          type: 'number',
          questionText: "Do you see any doctors, counselors, or agency workers?",
          answer: 'doctors_counselors',
        },
        {
          type: 'string',
          questionText: "If yes, please explain: ",
          answer: 'doctors_counselors_information'
        },
        {
          type: 'number',
          questionText: "Do you feel like you are being teased, picked on, bullied, or rejected by anymore?",
          answer: 'teased',
        },
        {
          type: 'string',
          questionText: "If yes, please explain: ",
          answer: 'teased_information'
        }
      ]
    },
    {
      sectionName: "Appearance and General Behavior",
      children: [
        {
          type: 'string',
          questionText: 'Dress:',
          answer: 'dress'
        },
        {
          type: 'string',
          questionText: 'Posture:',
          answer: 'posture'
        },
        {
          type: 'string',
          questionText: 'Facial Expression:',
          answer: 'facial_expression'
        },
        {
          type: 'string',
          questionText: 'Physical Activity:',
          answer: 'physical_activity'
        }
      ]
    },
    {
      sectionName: "Emotional Reaction",
      children: [
        {
          type: 'string',
          questionText: 'Attitude:',
          answer: 'attitude'
        },
        {
          type: 'string',
          questionText: 'Talk - Form:',
          answer: 'talk_form'
        },
        {
          type: 'string',
          questionText: 'Talk - Rate:',
          answer: 'talk_rate'
        },
        {
          type: 'string',
          questionText: 'Talk - Quality:',
          answer: 'talk_quality'
        },
        {
          type: 'string',
          questionText: 'Expressions:',
          answer: 'expressions'
        },
        {
          type: 'number',
          questionText: "Does individual know who he/she is?",
          answer: "self_knowledge",
        },
        {
          type: 'number',
          questionText: "Does individual know where he/she is?",
          answer: "self_location",
        },
        {
          type: 'number',
          questionText: "Does individual know how he/she feels?",
          answer: "self_feeling",
        }
      ]
    },
    {
      sectionName: "General Knowledge",
      children: [
        {
          type: 'string',
          questionText: "Counting from 20 to 1 backward:",
          answer: "student_counting",
        },
        {
          type: 'number',
          questionText: "Does the student know who the president is?",
          answer: "president",
        },
        {
          type: 'number',
          questionText: "Does the student know who the governor is?",
          answer: "governor",
        },
        {
          type: 'number',
          questionText: "Does the student know who the mayor is?",
          answer: "mayor",
        }
      ]
    }
  ];

  constructor(
    private studentOfConcernInterviewService: StudentOfConcernInterviewService
  ) { }

  ngOnInit(): void {
    this.loadStudentOfConcernInterview();
  }

  loadStudentOfConcernInterview(): void {
    if (this.caseId) {
      this.loading = true;      
      this.studentOfConcernInterviewService.getStudentOfConcernInterviewByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.studentInterview = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching student of concern interview:', error);
          this.loading = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
